<template>
    <div class="md:grid md:grid-cols-[3fr_7fr] md:gap-6">
        <jet-section-title>
            <template #title>
                <slot name="title"></slot>
            </template>
            <template #description>
                <slot name="description"></slot>
            </template>
        </jet-section-title>

        <div class="mt-5 md:mt-0">
            <form @submit.prevent="$emit('submitted')">
                <div
                    class="border-iron-200 bg-white px-4 py-5 shadow-xs sm:p-6 border"
                    :class="
                        hasActions
                            ? 'sm:rounded-tl-lg sm:rounded-tr-lg'
                            : 'sm:rounded-lg'
                    "
                >
                    <div class="gap-6 grid grid-cols-6">
                        <slot name="form"></slot>
                    </div>
                </div>

                <div
                    v-if="hasActions"
                    class="border-iron-200 bg-iron-25 px-4 py-4 shadow sm:rounded-bl-md sm:rounded-br-md sm:px-6 flex items-center justify-end border border-t-0 text-right"
                >
                    <slot name="actions"></slot>
                </div>
            </form>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, useSlots } from "vue";
import JetSectionTitle from "./SectionTitle.vue";

const slots = useSlots();

defineEmits(["submitted"]);
const hasActions = computed(() => {
    return !!slots.actions;
});
</script>
